import React, { useState, useEffect } from "react";
import { useBluelagoon } from "@bluelagoon";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@shadcn-in-nx/ui/dialog";
import { Button } from "@shadcn-in-nx/ui/button";
import { Input } from "@shadcn-in-nx/ui/input";
import { Search } from "lucide-react";

export default function BlueprintPickerDialog({ open, onClose, onSelect }) {
    const [search, setSearch] = useState("");
    const [blueprints, setBlueprints] = useState([]);
    const { call: getBlueprints, isLoading } = useBluelagoon({
        method: "getBlueprints",
    });

    useEffect(() => {
        if (!open) return;
        const timeout = setTimeout(() => {
            getBlueprints({ search, visibility: "PUBLIC", limit: "20" }).then(
                (res) => setBlueprints(res?.data?.blueprints || [])
            );
        }, 300);
        return () => clearTimeout(timeout);
    }, [open, search]);

    return (
        <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Select Blueprint</DialogTitle>
                    <DialogDescription>
                        Choose the blueprint that was built for this request.
                    </DialogDescription>
                </DialogHeader>
                <div className="relative">
                    <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                    <Input
                        placeholder="Search blueprints..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="pl-8"
                    />
                </div>
                <div className="max-h-64 overflow-y-auto space-y-1">
                    {isLoading && (
                        <p className="text-sm text-muted-foreground p-2">
                            Loading...
                        </p>
                    )}
                    {!isLoading && blueprints.length === 0 && (
                        <p className="text-sm text-muted-foreground p-2">
                            No blueprints found.
                        </p>
                    )}
                    {blueprints.map((bp) => (
                        <Button
                            key={bp.id}
                            variant="ghost"
                            className="w-full justify-start text-left h-auto py-2"
                            onClick={() => onSelect(bp.id)}
                        >
                            <div>
                                <p className="font-medium text-sm">{bp.name}</p>
                                {bp.description && (
                                    <p className="text-xs text-muted-foreground truncate max-w-[350px]">
                                        {bp.description}
                                    </p>
                                )}
                            </div>
                        </Button>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
